import React from "react";

import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ModalProvider } from "../../contexts/ModalContext";
import { InvitationInformation } from "../InvitationInformation";

interface IProps {
  reloadUser?: VoidFunction;
  invitations: any[];
  userName: string;
  registered: boolean;
}

export const UserInvitationsTree: React.FC<IProps> = (props) => (
  <TreeView
    disableSelection
    defaultExpanded={["1"]}
    defaultExpandIcon={<ChevronRightIcon />}
    defaultCollapseIcon={<ExpandMoreIcon />}
  >
    <TreeItem nodeId="1" label="Invitations">
      <ModalProvider>
        <InvitationInformation
          name={props.userName}
          triggerReload={props.reloadUser}
          invitations={props.invitations}
          registered={props.registered}
        />
      </ModalProvider>
    </TreeItem>
  </TreeView>
);
